import "./Places.css";
import bgImage from "../assets/pl.jpeg";

function Places() {
    return (
        <section className="places-section" id="places">
            <div
                className="places-background"
                style={{ backgroundImage: `url(${bgImage})` }}
            >
                <div className="overlay"></div>

                <div className="places-wrapper">
                    <div className="places-content">
                        <h1>You have a place here</h1>

                        <p>
                            Saplings Nursery is a dedicated space designed for the care, growth, and nurturing of young plants before they are transplanted to their permanent locations. It provides controlled environmental conditions such as adequate sunlight, water, soil nutrients, and  ensuring healthy plant development.
                        </p>
                    </div>

                    <div className="places-buttons">
                        <button>SAPLINGS</button>
                        <button>FLOWERING PLANTS</button>
                        <button>LANDSCAPING</button>
                        <button>TERRACE GARDENING</button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Places;